import { gql } from "apollo-angular";

const ADD_CROSS_REFERENCE_OPINION = gql`
          mutation addCrossReferenceOpinion(
            $crossReferenceId: Long!
            $fromProductId: Long!
            $toProductId: Long!
            $clinicalFeedback: String!
          ) {
            addCrossReferenceOpinion(
              addCrossReferenceOpinion: {
                crossReferenceId: $crossReferenceId
                fromProductId: $fromProductId
                toProductId: $toProductId
                clinicalFeedback: $clinicalFeedback
              }
            ) {
              opinion
            }
          }
        `;

export default ADD_CROSS_REFERENCE_OPINION;